import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { NextButtonAvailabilityContext } from '../../contexts/nextButtonAvailability.context'
import { StepHandlerContext } from '../../contexts/stepHandler.context'
import {
  selectSubscriptionPatternSubSteps,
  selectSubscriptionSizeSubSteps,
  selectSubscriptionStep
} from '../../store/subscription/subscription.selector'

import './next-button.styles.scss'

const NextButton = () => {
  const { t } = useTranslation('updatedBAB')
  const { nextStep } = useContext(StepHandlerContext)
  const { nextButtonAvailability } = useContext(NextButtonAvailabilityContext)

  const subscriptionStep = useSelector(selectSubscriptionStep)
  const sizeSubSteps = useSelector(selectSubscriptionSizeSubSteps)
  const patternSubSteps = useSelector(selectSubscriptionPatternSubSteps)

  const getNextButtonText = () => {
    switch (subscriptionStep) {
      case 0:
        return t('navigation.nextButton.toSize')
      case 1:
        if (sizeSubSteps.total === sizeSubSteps.completed) {
          return t('navigation.nextButton.toPattern')
        } else {
          return t('navigation.nextButton.next')
        }
      case 2:
        if (patternSubSteps.total === patternSubSteps.completed) {
          return t('navigation.nextButton.toUpsell')
        } else {
          return t('navigation.nextButton.next')
        }
      case 3:
        return t('navigation.nextButton.toCart')
      default:
        return t('navigation.nextButton.next')
    }
  }

  const nextButtonText = getNextButtonText()

  return (
    <button
      className='button next-button'
      disabled={!nextButtonAvailability}
      onClick={nextStep}
    >
      <p>{nextButtonText}</p>
      <svg
        width='15'
        height='9'
        viewBox='0 0 15 9'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M13.5397 4.50191H1M13.5397 4.50191L8.98016 0.808594M13.5397 4.50191L8.98016 8.19528' />
      </svg>
    </button>
  )
}

export default NextButton
